import React from 'react'
import PropTypes from 'prop-types'

class Star extends React.Component {
  static propTypes = {
    percent: PropTypes.number,
  }
  constructor (props) {
    super(props)
  }

  render () {
    const width = {
      width: this.props.percent + '%'
    }
    return (
      <div className='rating'>
        <span className='bottom-ratings'>
          <span className='fa fa-star-o' />
          <span className='fa fa-star-o' />
          <span className='fa fa-star-o' />
          <span className='fa fa-star-o' />
          <span className='fa fa-star-o' />
          <span style={width} className='top-ratings'>
            <span className='fa fa-star' />
            <span className='fa fa-star' />
            <span className='fa fa-star' />
            <span className='fa fa-star' />
            <span className='fa fa-star' />
          </span>
        </span>
      </div>
    )
  }
}

export default Star



// WEBPACK FOOTER //
// ./src/components/Star.js